import React from 'react'
import Helmet from 'react-helmet'
import './index.css'
import Footer from '../components/Footer'
import favicon from '../assets/favicon-32x32.png'

const Layout = ({ children, data }) => (
  <div>
    <Helmet>
      <title>shotsnapp - Create beautiful device mockup presentation </title>
      <link rel="shortcut icon" href={favicon} />
      <meta
        name="google-site-verification"
        content="J1hVH8u8eXibc3BILX34JlHm2lkXm70hhG8Z6kky1ZA"
      />
      <meta
        name="description"
        content="Create beautiful device mockup image from the screenshots or design of your mobile app and websites"
      />
      <meta
        name="keywords"
        content="screenshot, beautiful image, iphone template, real device, mockup iphone, device mockup generator, iphone templates, android mockup, design freebies"
      />
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, shrink-to-fit=no"
      />
      <meta content="http://shotsnapp.com" property="og:url" />
      <meta content="article" property="og:type" />
      <meta
        content="shotsnapp - Create beautiful mockup presentation"
        property="og:title"
      />
      <meta
        content="https://gaddafirusli.github.io/images/shotsnapp/cover-image.png"
        property="og:image"
      />
      <meta content="shotsnapp" property="og:site_name" />
      <meta
        content="A simple tool to quickly create beautiful mockup presentation for your digital app and website design"
        property="og:description"
      />
      <meta content="summary_large_image" name="twitter:card" />
      <meta content="@tryshotsnapp" name="twitter:site" />
      <meta content="@tryshotsnapp" name="twitter:creator" />
      <meta
        content="shotsnapp - Create beautiful mockup presentation"
        name="twitter:title"
      />
      <meta
        content="A simple tool to quickly create beautiful mockup presentation for your digital app and website design"
        name="twitter:description"
      />
      <meta
        content="https://gaddafirusli.github.io/images/shotsnapp/cover-image.png"
        name="twitter:image"
      />
    </Helmet>
    {children()}
    <Footer />
  </div>
)

export default Layout



// WEBPACK FOOTER //
// ./src/layouts/index.js